import { getAppBaseUrl } from './getAppBaseUrl';

/**
 * @group Functions
 * @summary <blockquote>Get the full URL for a specific path in the application.</blockquote>
 * @param path - The path to append to the base URL (should start with /)
 * @returns The full URL including the path
 * @example
 * ```typescript
 * const url = getAppUrl('/api/users');
 * // Returns: "https://example.com/api/users"
 * ```
 */
export function getAppUrl(path: string): string {
  const baseUrl = getAppBaseUrl();
  // Ensure path starts with / and remove any trailing slashes
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
} 